module.exports = __webpack_public_path__ + "flag-4e8cd11a890c1a77b16541f7df9325fc.svg";